// extracted by mini-css-extract-plugin
export default {"page":"Login_page__-HHZQ","loginForm":"Login_loginForm__QiL9D"};